import React, { Component } from 'react'
import { connect } from 'react-redux'
import classname from 'classnames'
import { updateTab, updatePopup, updatePopupTab } from '../../../actions/editordashboard'
import { getAdminSubmission, updateAdminSubmissionInput } from '../../../actions/Admin'
import TopNav from '../../includes/TopNav.js';
import { getAdminUserId, patchAdminUserId, updateAdminUserIdInput, getStudentDocuments, getEditorsAssignments } from '../../../actions/AdminUserId'
import {getFormattedTime, docStatusToString} from '../../../util/displayUtils.js';
import AdminDocumentsTable from './AdminDocumentsTable';
import StudentAffiliateCode from '../StudentAffiliateCode';
import EditorDocumentsTable from './EditorDocumentsTable';
import Pager from '../Pager.js';
import { Link } from 'react-router-dom'

import moment from 'moment'

class AdminUserId extends Component {
  constructor(props) {
    super(props)
    this.state = { activeTab: 1}
  }
  componentDidMount() {
      this.getAdminUserId(function() {
        if(this.props.AdminUserId.user) {
          if(this.props.AdminUserId.user.role == 'student') {
            this.getStudentDocuments();
          } else { // editor or (unlikely) admin
            this.getEditorsAssignments();
          }  
        }
      }.bind(this));
  }
  patchAdminUserId() {
      this.props.dispatch(patchAdminUserId(this.props.AdminUserId.user, this.props.match.params.userId, () => {
      }))
  }
  getAdminUserId(cb) {
      console.log(this.props.match);
      this.props.dispatch(getAdminUserId(this.props.match.params.userId, () => {
        cb();
      }))
  }
  getStudentDocuments() {
    this.props.dispatch(getStudentDocuments(this.props.match.params.userId));
  }
  getEditorsAssignments() {
    this.props.dispatch(getEditorsAssignments(this.props.match.params.userId));
  }
  updateAdminUserIdInput(key, e) {
      this.props.dispatch(updateAdminUserIdInput(key, e.target.value))
  }
  updateTab(index) {
    var newState = {activeTab: index}
    this.setState(newState);
  }
  nextDocumentsPage(page) {
    if(this.props.AdminUserId.user.role == 'editor') {
      this.props.dispatch(getEditorsAssignments(this.props.match.params.userId, page));
    } else {
      this.props.dispatch(getStudentDocuments(this.props.match.params.userId, page));
    }
  }
  render() {
    var tab1 = classname({ editorbutton: true, easing: true, active_tab: this.state.activeTab === 1 })
    var tab2 = classname({ editorbutton: true, easing: true, active_tab: this.state.activeTab === 2 })
    var page1 = classname({ editorpage: true, easing: true, activepage: this.state.activeTab === 1 })
    var page2 = classname({ editorpage: true, easing: true, activepage: this.state.activeTab === 2 })

    if(!this.props.AdminUserId.user) {
      return(
        <div>
          <TopNav/>
        </div>
      )
    }
    return(
      <div>
        <TopNav/>
        <br/><br/>
        <section id="admin-container">
        <div className="admin-options-wrapper">
          <div className={tab1} onClick={this.updateTab.bind(this, 1)}>
              Details
            </div>
            <div className={tab2} onClick={this.updateTab.bind(this, 2)}>
            {(this.props.AdminUserId.user.role == 'editor')? 
            <div>Edits</div>
            :
            <div>Documents</div>
            }
            </div>
          </div>
          <div className={page1}>
            <div className="admin-form">
              <div>
                <label className="small">Email</label>
                <input className="user-input" type="email" value={this.props.AdminUserId.user.email} onChange={this.updateAdminUserIdInput.bind(this, 'email')}/>
              </div>
              <div>
                <label className="small">First Name</label>
                <input className="user-input" type="text" value={this.props.AdminUserId.user.first_name} onChange={this.updateAdminUserIdInput.bind(this, 'first_name')}/>
              </div>
              <div>
                <label className="small">Last Name</label>
                <input className="user-input" type="text" value={this.props.AdminUserId.user.last_name} onChange={this.updateAdminUserIdInput.bind(this, 'last_name')}/>
              </div>
              <div>
                <StudentAffiliateCode code={this.props.AdminUserId.user.affiliate_code}></StudentAffiliateCode>
              </div>

              <div>
                <label className="small">Major</label>
                <input className="user-input" type="text" value={this.props.AdminUserId.user.major} onChange={this.updateAdminUserIdInput.bind(this, 'major')}/>
              </div>
              <div>
                <label className="small">University</label>
                <input className="user-input" type="text" value={this.props.AdminUserId.user.school} onChange={this.updateAdminUserIdInput.bind(this, 'school')}/>
              </div>
              <div>
                <label className="small">Year of Study</label>
                <input className="user-input" type="text" value={this.props.AdminUserId.user.study_year} onChange={this.updateAdminUserIdInput.bind(this, 'study_year')}/>
              </div>
              <div>
                <label className="small">Account Type</label>
                <select className="user-input" value={this.props.AdminUserId.user.role} onChange={this.updateAdminUserIdInput.bind(this, 'role')}>
                  <option value="student">Client</option>
                  <option value="editor">Editor</option>
                </select>
              </div>
              {(this.props.AdminUserId.user.role == 'editor')?
              <div>
                <label className="small"># of Edits Allowed</label>
                <input className="user-input" type="number" value={this.props.AdminUserId.user.edits_allowed} onChange={this.updateAdminUserIdInput.bind(this, 'edits_allowed')}/>
                <label className="small">Level</label>
                <select className="user-input" value={this.props.AdminUserId.user.level} onChange={this.updateAdminUserIdInput.bind(this, 'level')}>
                    <option value="">None</option>
                    <option value="silver">Proofreading</option>
                    <option value="gold">Standard</option>
                    <option value="pro">Ultimate</option>
                </select>
              </div>
                :
                <div></div>
              }
              <div>
                <label className="small">Account Status</label>
                <p className="flex">
                <input type="radio" checked={this.props.AdminUserId.user.role_status == 1} value="1" onChange={this.updateAdminUserIdInput.bind(this, 'role_status')}/> Active
                <input type="radio" checked={this.props.AdminUserId.user.role_status == 0} value="0" onChange={this.updateAdminUserIdInput.bind(this, 'role_status')}/> Inactive
                </p>
              </div>
              <div>
                <label className="small">HST Number</label>
                <input className="user-input" type="number" value={this.props.AdminUserId.user.hst_number} onChange={this.updateAdminUserIdInput.bind(this, 'hst_number')}/>
              </div>
              <div>
                <label className="small">HST Province</label>
                <select className="user-input" value={this.props.AdminUserId.user.hst_province} onChange={this.updateAdminUserIdInput.bind(this, 'hst_province')}>
                  <option value="">Select an Option</option>
                  <option value="AB">Alberta</option>
                  <option value="BC">British Columbia</option>
                  <option value="MB">Manitoba</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NL">Newfoundland and Labrador</option>
                  <option value="NS">Nova Scotia</option>
                  <option value="ON">Ontario</option>
                  <option value="PE">Prince Edward Island</option>
                  <option value="QC">Quebec</option>
                  <option value="SK">Saskatchewan</option>
                  <option value="NT">Northwest Territories</option>
                  <option value="NU">Nunavut</option>
                  <option value="YT">Yukon</option>
                </select>
              </div>
              <br />
              <br />
              <span>
                <Link to="/admindashboard/">Back</Link>
                <button className="load-more" onClick={this.patchAdminUserId.bind(this)}>Update Profile</button>
              </span>
            </div>
          </div>
          <div className={page2}>
          {(this.props.AdminUserId.user.role == 'student')? 
            <AdminDocumentsTable documents={this.props.AdminUserId.documents}></AdminDocumentsTable>
            :
            <EditorDocumentsTable documents={this.props.AdminUserId.documents}></EditorDocumentsTable>
          }
          <Pager totalCount={this.props.AdminUserId.documentsTotalCount} currentPage="1" 
            clickHandler={this.nextDocumentsPage.bind(this)} pageSize="20"></Pager>
          </div>
        </section>
      </div>
    )
  }
}

export default connect( ({Dashboard, AdminUserId}) => ({Dashboard, AdminUserId}) ) (AdminUserId)



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AdminUserDetails.js